import { useEffect as o } from "react";
function i({
  close: e,
  isOpen: n = !0,
  ref: t
}) {
  o(() => {
    function r(u) {
      n && u.target && t.current && !t.current.contains(u.target) && e();
    }
    return document.addEventListener("mousedown", r), () => {
      document.removeEventListener("mousedown", r);
    };
  }, [t, n, e]);
}
export {
  i as useOutsideAlerter
};
